import React, { useState, useEffect } from "react";
import { isMobile } from "react-device-detect";
import { useDebounce } from "../../core/hooks/useDebounce";

const SearchHeader = ({ filter, setFilter }) => {
  const [searchInput, setSearchInput] = useState(filter?.search || "");
  const debouncedSearch = useDebounce(searchInput, 500);

  // Update filter only when debounced value changes
  useEffect(() => {
    setFilter((filter) => ({ ...filter, search: debouncedSearch }));
  }, [debouncedSearch]);

  // Sync local state if filter.search changes externally
  useEffect(() => {
    if (filter?.search !== searchInput) {
      setSearchInput(filter?.search || "");
    }
  }, [filter?.search]);

  return (
    <div className="header-mobile">
      <div style={{ display: "flex", flexDirection: "row" }}>
        <div style={{ display: "flex", width: "100%", paddingRight: "10px" }}>
          {isMobile ? (
            <span className="rgt-search-icon custom-header-icon">⚲</span>
          ) : (
            <label className="rgt-search-label" htmlFor="rgt-search">
              <span className="rgt-search-icon custom-header-icon">⚲</span>
              Buscar:
            </label>
          )}
          <input
            className="rgt-search-input custom-header-input"
            type="search"
            placeholder="Digite para Pesquisar"
            value={searchInput}
            onChange={(e) => setSearchInput(e.target.value)}
            style={{ backgroundColor: "#D9DBE9", color: "black" }}
          />
        </div>
      </div>
    </div>
  );
};

export default SearchHeader;
